import type { HandleType } from '@xyflow/system';
import {
  decodeStringKey,
  encodeStringKey,
  isSafeFiniteInteger,
  type StringKey,
  type UUIDType,
} from '../../../common/utils';

export type AlgorithmJoinHandleId = StringKey<
  [UUIDType, number, HandleType, 'handle']
>;

export const getHandleId = (
  nodeId: UUIDType,
  itemIndex: number,
  type: 'source' | 'target',
): AlgorithmJoinHandleId => encodeStringKey(nodeId, itemIndex, type, 'handle');

export const parseHandleId = (handleId: AlgorithmJoinHandleId) => {
  const parts = decodeStringKey(handleId);
  return {
    nodeId: parts[0] as UUIDType,
    itemIndex: parseInt(parts[1], 10),
    type: parts[2] as 'source' | 'target',
  };
};

export const encodeDimensionCodeValue = (
  algorithmSourceId: number,
  dimensionCode: string,
) => encodeStringKey(algorithmSourceId, dimensionCode);

export const decodeDimensionCodeValue = (value: string) => {
  const parts = decodeStringKey(value);

  if (parts.length !== 2 || !isSafeFiniteInteger(parts[0])) {
    throw new Error(
      `Invalid dimension code value: "${value}". Expected format: ${encodeStringKey('<algorithmSourceId>', '<dimensionCode>')}`,
    );
  }

  return {
    algorithmSourceId: parseInt(parts[0], 10),
    dimensionCode: parts[1],
  };
};
